import { useReducer } from 'react';
import { MessageStandaloneViewMode } from '../../message-bar/MessageBarStandalone';
import { CareTeamTab, MessageTab } from '../../message-bar/MessageBarTabView';

export type MessageStandaloneDisplayConfig = {
  visible: boolean;
  viewMode: MessageStandaloneViewMode;
  activeTab: MessageTab;
  selectedChannelGuid?: string;
};

export type MessageStandaloneDisplayConfigAction =
  | {
      type: 'TOGGLE_VISIBLE';
    }
  | {
      type: 'RESET';
    }
  | {
      type: 'CHANGE_TAB';
      payload: { newTab: MessageTab };
    }
  | {
      type: 'START_CONVERSATION';
      payload: {
        selectedChannelGuid: string;
        activeTab: MessageTab;
      };
    }
  | {
      type: 'CHANGE_VIEW_MODE';
      payload: {
        viewMode: MessageStandaloneViewMode;
        activeTab?: MessageTab;
        selectedChannelGuid?: string;
      };
    };

const DISPLAY_CONFIG_INIT: MessageStandaloneDisplayConfig = {
  visible: false,
  viewMode: 'channels',
  activeTab: CareTeamTab,
};

export const useMessageStandaloneConfigReducer = () => {
  const [store, dispatch] = useReducer(reducer, DISPLAY_CONFIG_INIT);
  return { store, dispatch };
};

const reducer = (
  store: MessageStandaloneDisplayConfig,
  action: MessageStandaloneDisplayConfigAction,
): MessageStandaloneDisplayConfig => {
  if (action.type === 'TOGGLE_VISIBLE') {
    return { ...store, visible: !store.visible };
  }
  if (action.type === 'RESET') {
    return { ...DISPLAY_CONFIG_INIT };
  }
  if (action.type === 'CHANGE_TAB') {
    return { ...store, activeTab: action.payload.newTab };
  }
  if (action.type === 'START_CONVERSATION') {
    return {
      ...store,
      viewMode: 'messaging',
      visible: true,
      ...action.payload,
    };
  }
  if (action.type === 'CHANGE_VIEW_MODE') {
    return { ...store, ...action.payload };
  }
  throw Error(`Unsupported action ${action}`);
};
